import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import {
  addCartDiscount,
  removeCartDiscount
} from '@/modules/cart/infrastructure/CartReduxRepository/CartReduxRepository';
import { useGetCouponCartData } from '@/modules/perseo-billing/containers/billing/Summary/hooks';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks/use-gtm-billing';
import { setCouponData } from '@/modules/perseo-billing/store/slices/billing';

const useCoupon = () => {
  const { couponData } = useAppSelector((state) => state.billing);
  const dispatch = useAppDispatch();

  const couponApplied = useGetCouponCartData();

  const { errorOnCoupon, invalidCouponGtm } = useGtmBillingProduct();

  const applyCoupon = (coupon: string) => {
    const couponCode = coupon || couponData?.value || '';
    dispatch(
      addCartDiscount({
        discountCode: couponCode,
        sendErrorCouponGtm: errorOnCoupon,
        sendInvalidCouponGtm: invalidCouponGtm,
        mode: 'billing'
      })
    );
  };

  const removeCoupon = () => {
    const discountCode = couponApplied?.coupons?.[0]?.couponId ?? '';
    try {
      dispatch(setCouponData(null));
      dispatch(removeCartDiscount(discountCode));
    } catch (error) {
      console.warn('Error removing coupon:', error);
    }
  };

  return {
    coupon: couponData?.value || '',
    buttonDisabled: couponData?.buttonDisabled ?? true,
    status: couponData?.status,
    value: couponData?.value || '',
    helperText: couponData?.helperText || '',
    coupons: couponApplied?.coupons,
    couponName: couponApplied?.coupons?.[0]?.couponName || '',
    onAdd: applyCoupon,
    removeCoupon: removeCoupon
  };
};

export default useCoupon;
